import React from 'react';
import { IconProps } from '../IconProps';
const SvgMicrophone = ({
  primaryColor,
  secondaryColor,
  tertiaryColor,
  ...props
}: IconProps) => (
  <svg width="1em" height="1em" viewBox="0 0 32 32" fill="none" {...props}>
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M17 24v7h-2v-7h2zM23 8v7a7 7 0 11-14 0V8a7 7 0 1114 0z"
      fill={primaryColor}
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M10 29h12v2H10v-2zM25 15v-2h2v2c0 6.075-4.925 11-11 11S5 21.075 5 15v-2h2v2a9 9 0 1018 0z"
      fill={primaryColor}
    />
  </svg>
);
export default SvgMicrophone;
